import { render, staticRenderFns } from "./SignPDFViewer.vue?vue&type=template&id=6af195b0"
import script from "./SignPDFViewer.vue?vue&type=script&lang=js"
export * from "./SignPDFViewer.vue?vue&type=script&lang=js"
import style0 from "./SignPDFViewer.vue?vue&type=style&index=0&id=6af195b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports